import UserRoleGroupsService from '../services/user-role-groups-service';

export const userRoleGroups = {
  namespaced: true,
  state: {
    all: null,
    userRoleGroup: null,
  },
  actions: {
    getAll({ commit }) {
      commit('setIsBusy', true, { root: true });
      return UserRoleGroupsService.list()
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setAll', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    create({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      return UserRoleGroupsService.create(data)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    get({ commit }, userRoleGroupId) {
      commit('setIsBusy', true, { root: true });
      commit('setUserRoleGroup', null);
      return UserRoleGroupsService.get(userRoleGroupId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setUserRoleGroup', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    update({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      return UserRoleGroupsService.update(data)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    delete({ commit }, userRoleGroupId) {
      commit('setIsBusy', true, { root: true });
      return UserRoleGroupsService.delete(userRoleGroupId)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setAll(state, newAll) {
      state.all = Array.isArray(newAll)
        ? newAll.map((roleGroup) => ({
          ...roleGroup,
          roles: Array.isArray(roleGroup.roles) ? [...roleGroup.roles] : [],
          }))
        : newAll;
    },
    setUserRoleGroup(state, newUserRoleGroup) {
      state.userRoleGroup = newUserRoleGroup;
    },
  },
};
